<div class="drawer-content">
    <ng-content></ng-content>
</div>
